import styled from "styled-components";

const MatchPredictionsWrapper = styled.div``;

export { MatchPredictionsWrapper };
